var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-card',{staticClass:"cursor-pointer",attrs:{"shadow":"hover"},nativeOn:{"click":function($event){return _vm.selectTopic(_vm.topic)}}},[_c('el-row',{attrs:{"type":"flex","align":"middle","justify":"space-between"}},[_c('span',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm.topic))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }